import { render, staticRenderFns } from "./StructureBasedForm.vue?vue&type=template&id=075e78ac&scoped=true"
import script from "./StructureBasedForm.vue?vue&type=script&lang=js"
export * from "./StructureBasedForm.vue?vue&type=script&lang=js"
import style0 from "./StructureBasedForm.vue?vue&type=style&index=0&id=075e78ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075e78ac",
  null
  
)

export default component.exports